import React from "react";
import "./ReportsView.css";
import Grid from '@mui/material/Grid2';
import { TextField, InputAdornment, Autocomplete, CircularProgress } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { GlobalContext } from "../../Context/GlobalContext";
import useAxios from '../../Hooks/useAxios';
import ReportsGantt from "../../Components/ReportsGantt/ReportsGantt";
import ReportsMetricCards from "../../Components/ReportsMetricCards/ReportsMetricCards";

/**
 * A container component for displaying the reports dashboard.
 * Focuses on rendering the top metrics and the main Gantt chart.
 *
 * @component
 * @returns {React.Element} The rendered ReportsView component.
 */
function ReportsView() {
  const ref = React.useRef(null);
  //const { setCurrentTab, currentTab } = React.useContext(GlobalContext);
  const { setCurrentTab, currentTab, setNewTaskOpen, eventDate, setAlertBarOpen, setAlertBarMessage, setAlertBarSeverity } = React.useContext(GlobalContext);
  const { data, isLoading, error } = useAxios("allSubprocessesDetails");
  const { data2, isLoading2, error2 } = useAxios("departments_employees");
  const [searchTerm, setSearchTerm] = React.useState("");
  const [searchTermCenter, setSearchTermCenter] = React.useState("");
  const [searchTermType, setSearchTermType] = React.useState("");
  const [departments, setDepartments] = React.useState([]);
  // const departments = React.useMemo(() => {
  //   return data2?.departments?.map(item => ({
  //     value: item.id,
  //     label: item.name
  //   })) || [];
  // }, [data2]);
  const [centers, setCenters] = React.useState([]);
  const [department, setDepartment] = React.useState({});
  const [center, setCenter] = React.useState({});
  const depts = extractDepartments(data);
  const cent = extractCenter(data);
  const projectType = extractProjectType(data);
  const dataProject = projectFiltering(data, searchTermCenter, searchTermType);

  /**
   * CSS styles for the container element.
   * Modificado para permitir crecimiento vertical y scroll interno si es necesario.
   * * @type {Object}
   * @property {string} minHeight - The minimum height to fill the available viewport.
   * @property {string} height - Set to auto to allow content-driven growth.
   * @property {string} bgcolor - The background color of the container.
   * @property {number} flexGrow - The flex-grow value for the container.
   * @property {string} overflowY - Controls the vertical scroll behavior.
   * @property {string} paddingBottom - Provides extra space at the end of the scroll.
   */
  const ContainerStyle = {
    minHeight: "calc(100vh - 110px)",
    height: "auto",
    bgcolor: "transparent",
    flexGrow: 1,
    overflowY: "auto",
    paddingBottom: "20px"
  };

  /**
   * Handles the search input change.
   * @param {React.ChangeEvent<HTMLInputElement>} event - The input change event.
   */
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());

  };

  //const handleSearchChangeProcess = (event) => {
  //    setSearchTermProcess(event.target.value.toLowerCase());
  //  };

  // const handleDepartmentChange = (event, values) => {
  //   setDepartment(values && {name: values.label, id: parseInt(values.value)});
  // }

  function projectFiltering(data, searchTermProject, searchTermType) {
    console.log("**searchTermProject: ", searchTermProject);
    console.log("**searchTermType: ", searchTermType);
    let dataProject;
    if (searchTermProject == "" && searchTermType == "")
    {
        console.log("**data: ", data);
        return data;
    } else if (searchTermType == "")
    {
        dataProject = data.filter(
          item => (item.targetCenter === searchTermProject )
        );
    } else if (searchTermProject == "")
    {
        dataProject = data.filter(
          item => (item.process === searchTermType )
        );
    }
    else
    {
        dataProject = data.filter(
          item => (item.process === searchTermType && item.targetCenter === searchTermProject)
        );
    }

    return dataProject;
  }

  function extractProjectType(data) {
      return [... new Set(data?.map(item => item.process) || [])];
    }

  function extractDepartments(data) {
    return [... new Set(data?.map(item => item.department) || [])];
  }

  function extractCenter(data) {
     return [... new Set(data?.map(item => item.targetCenter) || [])];
   }

  const handleCenterChange = (event, value) => {

    setSearchTermCenter(value || "");
    console.log("handleCenterChange:", value);
  };

  const handleTypeChange = (event, value) => {

      setSearchTermType(value || "");
      console.log("handleCenterType:", value);
    };


  const handleDepartmentChange = (event, value) => {

     if (value) {
       setSearchTerm(value.toLowerCase());
     } else {
       setSearchTerm("");
     }
    };


  // const handleCenterChange = (event, values) => {
  //   //
  //   if(setSearchTermCenter != null)
  //   {
  //       setCenter(values && values.label);
  //       setSearchTermCenter(values.toLowerCase());
  //   }
//
  //   else
  //       setSearchTermCenter("");
  // }

  // const handleDepartmentChange = (event, values) => {
  //     setDepartment(values.toLowerCase());
  //     setSearchTerm(values.toLowerCase());
  //   }


  return (

    <div ref={ref} className="container_body" style={ContainerStyle}>
      <Grid container spacing={2}>

        {/* Sección de configuración de filtrado */}
        <Grid
          size={{ xs: 12, md: 4, lg: 3 }}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            ml: 'auto'
          }}
        >

        <Autocomplete
           disablePortal
           required
           options={projectType}
           onChange={handleTypeChange}
           sx={{ width: 2260 , marginTop: "10px"}}
           renderInput={(params) => <TextField {...params} label="Process type"/>}
           ListboxProps={{ style: { maxHeight: '15rem' } }}
           noOptionsText={isLoading2? <><CircularProgress size="1rem" sx={{marginRight: "4px"}} />Loading...</> : error && error || "No options"}
         />

        <Autocomplete
          disablePortal
          required
          options={cent}
          onChange={handleCenterChange}
          sx={{ width: 2260 , marginTop: "10px"}}
          renderInput={(params) => <TextField {...params} label="Centers"/>}
          ListboxProps={{ style: { maxHeight: '15rem' } }}
          noOptionsText={isLoading2? <><CircularProgress size="1rem" sx={{marginRight: "4px"}} />Loading...</> : error && error || "No options"}
        />

        <Autocomplete
          disablePortal
          required
          options={depts}
          onChange={handleDepartmentChange}

          sx={{ width: 2260 , marginTop: "10px"}}
          renderInput={(params) => <TextField {...params} label="Department"/>}
          ListboxProps={{ style: { maxHeight: '15rem' } }}
          noOptionsText={isLoading2? <><CircularProgress size="1rem" sx={{marginRight: "4px"}} />Loading...</> : error && error || "No options"}
          />





        </Grid>

        {/* Sección de métricas: Tarjetas de KPI principales */}
        <Grid size={{ xs: 12 }}>
          <ReportsMetricCards
            strDepartment = {searchTerm}
            data={dataProject}
          />
        </Grid>

        {/* Sección del Gráfico de Gantt: Visualización de cronograma y procesos */}
        <Grid size={{ md: 12, lg: 12 }}>
          <ReportsGantt
            data={dataProject}
            isLoading={isLoading}
            error={error}
            searchTerm={searchTerm}
            searchTermProcess={searchTermCenter}
            searchTermType={searchTermType}
          />
        </Grid>

      </Grid>
    </div>
  );
}

export default ReportsView;